import { AuthenticatedTemplate, useIsAuthenticated } from '@azure/msal-react';
import { ReactElement, ReactNode, useCallback, useMemo, useState } from 'react';
import Drawer from './Drawer';
import DrawerContext, { ActivateDrawer } from './drawer-context';
import { useGetUserQuery } from '@/app/services/solution';

const DRAWER_WIDTH_DEFAULT = 500;

const DrawerProvider = ({ children }: { readonly children: ReactNode }): ReactElement => {
  const [content, setContent] = useState<ReactNode>();
  const [drawerWidth, setDrawerWidth] = useState<number>(DRAWER_WIDTH_DEFAULT);
  const isAuthenticated = useIsAuthenticated();
  const userQuery = useGetUserQuery(void 0, { skip: !isAuthenticated });

  const activateDrawer = useCallback<ActivateDrawer>(({ content, drawerWidth = DRAWER_WIDTH_DEFAULT }) => {
    setContent(content);
    // Sometimes rare times window.outerWidth seems to be zero
    setDrawerWidth(Math.min(window.outerWidth, drawerWidth) || drawerWidth);
  }, []);

  const deactivateDrawer = useCallback((): void => {
    setContent(undefined);
  }, []);

  const value = useMemo(
    () => ({
      drawerWidth,
      activateDrawer,
      deactivateDrawer,
    }),
    [drawerWidth, activateDrawer, deactivateDrawer],
  );

  return (
    <DrawerContext value={value}>
      {userQuery.data && (
        <AuthenticatedTemplate>
          <Drawer drawerWidth={drawerWidth}>{content}</Drawer>
        </AuthenticatedTemplate>
      )}
      {children}
    </DrawerContext>
  );
};

export default DrawerProvider;
